/*
   This component handles Job Descriptions pills.
   Takes in job title - should render only if job title is there.

   renders the suggestions below the job title.
   handles the Suggestions overlay when user selects more.
   returns back template when user selects/clicks a template title
*/
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import {
   formValueSelector, change as changeFieldValue
} from "redux-form";
import { of, BehaviorSubject } from "rxjs";
import {
   debounceTime, map, distinctUntilChanged, switchMap, catchError
} from "rxjs/operators";

import JobDescriptionsModal from "./JobDescriptionsModal";

import { getTemplateSuggestions, getTemplateDescription } from "../../../../services/suggestions/job";

const suggestionJobTitleSubject$ = new BehaviorSubject("");
const suggestionJobTitleObservable$ = suggestionJobTitleSubject$.pipe(
   debounceTime(300),
   distinctUntilChanged(),
   switchMap((input) => {
      return getTemplateSuggestions({ "keywords": input, "minSuggestions": 1, "maxSuggestions": 5 }).pipe(
         map((data) => { return data }),
         catchError((error) => { console.log(error); return of({ templates: [] }) })
      )
   })
);

class JobDescriptionsUI extends Component {

   constructor(props) {
      super(props);
      this.state = {
         templateSuggestions: [],
         showSelectionOverlay: false
      }
      this.onTemplateSelect = this.onTemplateSelect.bind(this);
      this.onShowSuggestionsOverlay = this.onShowSuggestionsOverlay.bind(this);
      this.selectOverlayToggle = this.selectOverlayToggle.bind(this);
      this.onUseDescription = this.onUseDescription.bind(this);
   }

   componentDidMount() {
      this.subscription = suggestionJobTitleObservable$.subscribe(
         (data) => {
            this.setState({
               templateSuggestions: data.templates
            });
         });
   }

   componentDidUpdate(prevProps) {
      // --- check for the jobTitle change here --- //
      if (this.props && this.props.jobTitle && (prevProps.jobTitle !== this.props.jobTitle)) {
         suggestionJobTitleSubject$.next(this.props.jobTitle);
      }
   }

   componentWillUnmount() {
      this.subscription.unsubscribe();
      if (this.templateSubscription) {
         this.templateSubscription.unsubscribe();
      }
   }

   onTemplateSelect(template) {
      if (template && template.id) {
         if (this.templateSubscription) {
            this.templateSubscription.unsubscribe();
         }
         this.templateSubscription = getTemplateDescription(template.id).pipe(
            map((data) => data),
            catchError((err) => {
               return of({
                  template: { id: null, title: null, description: null }
               })
            })
         ).subscribe((response) => {
            if (response.template && response.template.description) {
               this.onUseDescription(response.template.description);
            }
         })
      }
   }

   onShowSuggestionsOverlay(event) {
      this.setState({
         showSelectionOverlay: true
      });
      event.preventDefault();
      event.stopPropagation();
   }

   selectOverlayToggle() {
      this.setState({
         showSelectionOverlay: false
      });
   }

   onUseDescription(description) {
      const { dispatch } = this.props;

      dispatch(changeFieldValue('employerJobDetails', 'jobDescription', description));
      this.setState({
         showSelectionOverlay: false
      });
   }

   render() {
      const { jobTitle } = this.props;
      // --- NOTE: use this is what needs to be mapped when wired properly --- //
      const { templateSuggestions } = this.state;
      const onTemplateSelect = this.onTemplateSelect;
      const onShowSuggestionsOverlay = this.onShowSuggestionsOverlay;

      // --- NOTE: hardcoded response if unable to proxy backend backend API --- //
      // const templates = [
      //    {title: "Osteopathy Doctor", id: "29367"},
      //    {title: "Doctor of Dental Medicine", id: "12995"},
      //    {title: "Dental Surgery Doctor", id: "11951"},
      //    {title: "Doctor of Dental Surgery", id: "12997"},
      // ]

      return (
         <Fragment>
            {
               jobTitle && jobTitle.length > 0 &&
               templateSuggestions.length > 0 &&
               <Fragment>
                  <div className="mt-3 mb-3">
                     <div>
                        {templateSuggestions.length > 0 && (
                           <Fragment>
                              {
                                 templateSuggestions.map((template, index) => (
                                    <button
                                       onClick={(event) => onTemplateSelect(template)}
                                       type="button"
                                       className="btn btn-label-gray btn-sm mr-2 mb-2"
                                       key={template.id}
                                    >
                                       {template.title}
                                    </button>
                                 ))
                              }
                           </Fragment>
                        )}
                        <button
                           type="button"
                           onClick={onShowSuggestionsOverlay}
                           className="btn btn-label-primary btn-sm mb-2"
                        >
                           Show More
                              </button>
                     </div>
                  </div>
                  <JobDescriptionsModal
                     search={jobTitle}
                     isVisible={this.state.showSelectionOverlay}
                     toggle={this.selectOverlayToggle}
                     onUseDescription={this.onUseDescription}
                  />
               </Fragment>
            }
         </Fragment>
      )
   }

}

const selectEmployerJobDetails = formValueSelector('employerJobDetails');

const mapStateToProps = (state) => {
   return {
      jobTitle: selectEmployerJobDetails(state, 'title'),
   }
}

export default connect(mapStateToProps)(JobDescriptionsUI);
